<template>
  <div
    class="renderer"
    :style="{
      width: `${width}px`,
      height: `${height}px`,
      minWidth: `${minWidth}px`,
      minHeight: `${minHeight}px`,
      backgroundColor: clearColor
    }"
  >
    <div class="renderer__inner">
      <div
        ref="rendererCanvas"
        class="renderer__canvas"
        :style="{
          transform: `scale(${scale})`,
          imageRendering: imageRendering
        }"
      />
    </div>
    <div class="renderer__components">
      <template v-if="renderEcs">
        <template v-for="entity in entities">
          <component
            :is="ecsRenderComponents['VueLogo']"
            :key="entity.uid"
            :entity="entity"
          />
        </template>
      </template>
      <slot />
    </div>
  </div>
</template>

<script>
import { Application } from 'pixi.js'

export default {
  provide () {
    return {
      renderer: this
    }
  },
  
  props: {
    useEcs: {
      type: Boolean
    },

    ecsRenderComponents: {
      type: Object
    },

    scale: {
      type: Number,
      default: 1
    },

    pixelScale: {
      type: Number,
      default: 1
    },

    baseWidth: {
      type: Number, // pixels
      default: 1920
    },

    baseHeight: {
      type: Number, // pixels
      default: 1080
    },

    clearColor: {
      type: String, // any CSS color string
      default: 'transparent'
    },

    imageRendering: {
      type: String, // 'auto', 'pixelated',
      default: 'pixelated'
    }
  },

  computed: {
    minWidth () {
      return this.baseWidth/this.pixelScale
    },

    minHeight () {
      return this.baseHeight/this.pixelScale
    },

    width () {
      return this.minWidth*this.scale
    },

    height () {
      return this.minHeight*this.scale
    },

    displayObject () {
      return this.pixi.stage
    },

    renderEcs () {
      return this.useEcs
        && this.$store
        && this.$store.state.entities
        && this.$store.state.components
    },

    entities () {
      return this.$store.getters.renderableEntities
    }
  },

  data () {
    return {
      pixi: new Application({
        width: this.baseWidth / this.pixelScale,
        height: this.baseHeight / this.pixelScale,
        transparent: true
      })
    }
  },

  mounted () {
    this.$refs.rendererCanvas.appendChild(this.pixi.view)
    this.pixi.ticker.add((delta) => this.$emit('draw', delta))
  },

  beforeDestroy () {
    this.pixi.destroy()
  }
}
</script>

<style lang="sass">
.renderer
  margin: auto
  position: relative

.renderer__inner
  top: 0
  left: 0
  width: 100%
  height: 100%
  z-index: 1
  position: absolute

.renderer__canvas
  transform-origin: 0 0

.renderer__components
  display: none
</style>
